import * as CommonUtilities from "../../../../common/utils/CommonUtils";
import defaultImage from "../../../../images/default.jpg";

export default function ModifierComboGroupDetailsModifier(props) {
    
    let modifierPriceInc = CommonUtilities.formatDisplayPrice(props.modifierDetails.priceInc);
    
    // Modifiers
    let modifierLabel;
    let priceLabel;
    let modifierSelector;
    let isDisabledCursor = props.isDisabled ? "default" : "pointer";

    if (props.type === "Radio") { // Note Modifier Combo Groups can only contain radios
        modifierLabel = <label className="form-check-label col" htmlFor={`RadioModComboModCatId${props.modifierFormData.ModifierCategoryID}ModGroupIndex${props.selectedGroupFormData.ModComboGroupIndex}ModId${props.modifierDetails.modId}`}>{props.modifierDetails.modName}</label>
        priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`RadioModComboModCatId${props.modifierFormData.ModifierCategoryID}ModGroupIndex${props.selectedGroupFormData.ModComboGroupIndex}ModId${props.modifierDetails.modId}`}>{modifierPriceInc}</label>
        modifierSelector = <div className="form-check ms-1">
                                <input type="radio" 
                                    value={props.modifierDetails.modId} 
                                    data-modplu={props.modifierDetails.modPLUNumber} 
                                    name={`RadioModComboModCatId${props.modifierFormData.ModifierCategoryID}ModGroupIndex${props.selectedGroupFormData.ModComboGroupIndex}ModId${props.modifierDetails.modId}`} 
                                    id={`RadioModComboModCatId${props.modifierFormData.ModifierCategoryID}ModGroupIndex${props.selectedGroupFormData.ModComboGroupIndex}ModId${props.modifierDetails.modId}`} 
                                    checked={props.modifierFormData.IsChecked} 
                                    disabled={props.isDisabled}
                                    style={{cursor: isDisabledCursor}}
                                    onChange={props.handleModifierChangeModComboGroup} />
                            </div>
    }

    return (
        <div className="col-12 d-flex justify-content-between py-2 align-items-center">
            {CommonUtilities.StaticFields.ShowModifierImages ? 
            <div className="me-3">
                <img src={props.modifierDetails.modImageURL ? props.modifierDetails.modImageURL : defaultImage} className="rounded-3 w-100 shadow-sm" style={{objectFit: "cover", objectPosition: "center center", aspectRatio: "1/1", maxWidth: "70px", minWidth: "70px"}} alt="Modifier"></img>
            </div>
            : <></>}
            {modifierLabel}
            <div className="d-flex justify-content-between">
                {props.modifierDetails.priceInc != 0 && priceLabel}
                {modifierSelector}
            </div>
        </div>
    )
}